module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 8.b88d6ee1.png";